import { State } from '../Store';

export const selectTraffic = (state: State) => state.traffic;
